import { feathersClient } from './index';

export const Users = feathersClient.service('users');
export const ChangePassword = feathersClient.service('change-password');
export const ResetPassword = feathersClient.service('reset-password');
export const OtpLogin = feathersClient.service('otp-login');
export const Country = feathersClient.service('country');
export const Region = feathersClient.service('region');
export const Category = feathersClient.service('category');
export const AddOnCategory = feathersClient.service('addon-category');
export const BundleCategory = feathersClient.service('bundle-category');
export const BundleSubcategory = feathersClient.service('bundle-subcategory');
export const BundleProduct = feathersClient.service('bundle-product');
export const BundleCake = feathersClient.service('bundle-cake');
export const AddOnProduct = feathersClient.service('addon-product');
export const AddOnProductVariant = feathersClient.service('addon-product-variant');
export const Color = feathersClient.service('color');
export const CakeBox = feathersClient.service('cake-box');
export const Shape = feathersClient.service('shape');
export const Flavor = feathersClient.service('flavor');
export const ToppingsCategory = feathersClient.service('topping-category');
export const ToppingsCategoryItem = feathersClient.service('topping-category-item');
export const CategoryCake = feathersClient.service('category-cake');
export const PromoCode = feathersClient.service('promo-code');
export const Order = feathersClient.service('order');
export const OrderItem = feathersClient.service('order-item');
export const OrderCake = feathersClient.service('order-cake');
export const CakeEdit = feathersClient.service('cake-edit');
export const WalletTransaction = feathersClient.service('wallet-transaction');
export const Reward = feathersClient.service('reward');
export const Referral = feathersClient.service('referral');
export const OrderStatusChange = feathersClient.service('order-status-change');
export const RegenerateOrderPaymentLink = feathersClient.service(
  'regenerate-order-payment-link'
);
export const DashboardReport = feathersClient.service('dashboard-reports');
export const AdminAnalyticsService = feathersClient.service('admin-analytics');
export const PushNotificationManagement = feathersClient.service('push-notification-management');
export const Settings = feathersClient.service('settings');
export const Slider = feathersClient.service('sliders');
export const AllSlider = feathersClient.service('all-sliders');
export const DownloadInvoice = feathersClient.service('download-invoice');
export const DownloadOrderDetails = feathersClient.service('download-order-details');
export const ContactForm = feathersClient.service('contact-form');
export const Notification = feathersClient.service('notification');
export const SellingCakeReport = feathersClient.service('selling-cake-report');
export const CardMessage = feathersClient.service('card-message');
export const Address = feathersClient.service('address');
export const ShippingAddress = feathersClient.service('shipping-address');
export const LocationCoordinates = feathersClient.service('location-coordinates');
export const DeliverySlot = feathersClient.service('delivery-slot');
export const AvailableDeliverySlots = feathersClient.service('available-delivery-slots');
export const DeliveryTimeSlotConfig = feathersClient.service('delivery-time-slot-config');
export const DeliverySlotException = feathersClient.service('delivery-slot-exception');
export const RecipientDetailsEdit = feathersClient.service('recipient-details-edit');
export const ExactDeliverySlot = feathersClient.service('exact-delivery-slot');
export const CreateCustomer = feathersClient.service('create-customer');
export const GetInitialData = feathersClient.service('get-initial-data');
export const Wishlist = feathersClient.service('wishlist');
export const Partner = feathersClient.service('partner');
export const PartnerApiKey = feathersClient.service('partner-api-key');
export const PartnerAuditLog = feathersClient.service('partner-audit-log');
export const ServiceVendor = feathersClient.service('service-vendor');
export const ServiceCategory = feathersClient.service('service-category');
export const ServiceProduct = feathersClient.service('service-product');
export const OrderServiceItem = feathersClient.service('order-service-item');
export const ServiceVendorExport = feathersClient.service('service-vendor-export');